import * as React from 'react';
import { useEffect ,useState } from 'react';
import { Error } from 'react-error-popup';
import { AppContext } from '../../../Context/AppContext';
import { postier } from './Postier';

export function Create({setPage}) {

    const { token,client,site, setErrors } = React.useContext(AppContext);

    const [entitys, setEntitys] = useState([]);
    const [fields, setFields] = useState({source:"",destination:"",coef:"0",debut:"",fin:""});

    useEffect(() => {
        postier.getEntities(token,client,site,setEntitys, setErrors)
    }, [])

    useEffect(() => {
      if (entitys.length !== 0) {
          const copyFields = { ...fields }
          copyFields['source'] = entitys[0].id_entity_analyzed
          copyFields['destination'] = entitys[0].id_entity_analyzed
          setFields(copyFields)
      }
    }, [entitys])

    const submit = () => {
        if (validate()) {
            const event = {
                Code: client.split(':')[0],
                id_site: site.split(':')[0],
                SourceEntityID: fields.source,
                DestinationEntityID: fields.destination,
                Coef: parseFloat(fields.coef),
                EntityMapping : 0,
                FromDate: fields.debut,
                ToDate: fields.fin,
                apiId: localStorage.getItem('apiId'),
                Database: client.split(":")[3]
            }
            
            postier.createCoef(token,event, setPage, setErrors)
        }
    }

    const validate = () => {
        for (var evt in fields) {
            if (fields[evt] === '') {
                setErrors((errors: string[]) => [...errors, `${evt} ne peut pas être vide`])
                return false;
            }
        }

        if (fields.debut > fields.fin) {
            setErrors((errors: string[]) => [...errors, 'La date de début ne peut pas être supérieure à la date de fin'])
            return false;
        }

        if (fields.destination === fields.source) {
            setErrors((errors: string[]) => [...errors, 'La source doit être différente de la destination'])
            return false
        }

        return true;
    }

    const handleChange = (field: string, e) => {
        const fieldsCopy = {...fields};
        fieldsCopy[field] = e.target.value;
        setFields(fieldsCopy);
    };

    const handleWheel = () => {
        if (parseFloat(fields.coef) < 0.1) {
            const fieldsCopy = {...fields};
            fieldsCopy["coef"] = "0.1"
            setFields(fieldsCopy)
        }
    }

    const handleFocus = () => {
        document.body.style.overflow = 'hidden'
    }

    const handleBlur = () => {
      document.body.style.overflow = 'scroll'
    }


  return (
    <div className="form">
      <label>Entity source </label>
      <select value={fields.source} onChange={e=>{handleChange("source",e)}} >
        {entitys.map(entity => <option key={entity.id_entity_analyzed} value={entity.id_entity_analyzed}>{entity.entity_analyzed_name}</option>)}
      </select>
      <label>Entity destination </label>
      <select value={fields.destination} onChange={e=>{handleChange("destination",e)}} >
        {entitys.map(entity => <option key={entity.id_entity_analyzed} value={entity.id_entity_analyzed}>{entity.entity_analyzed_name}</option>)}
      </select>
      <label >Coefficient</label> <input type="number" onWheel={handleWheel} onFocus={handleFocus} onBlur={handleBlur} step={0.1} value={fields.coef} onChange={e=>{handleChange("coef",e)}} />
      <label >Date de début</label> <input type="date" value={fields.debut} onChange={e=>{handleChange("debut",e)}} />
      <label >Date de fin</label> <input type="date" value={fields.fin} onChange={e=>{handleChange("fin",e)}} />

      <button onClick={submit} >Appliquer</button>
    </div>
  );
}